<template>
  <main class="notice_page">
    <header class="notice_header">
      <button type="button" class="back_button" :aria-label="$t('feng.back')" @click="$router.back()"><span /></button>
      <h1>{{ $t('notice.detail') }}</h1>
      <span class="header_spacer" aria-hidden="true" />
    </header>
    <section class="notice_content">
      <article class="notice_card">
        <header class="notice_card_header">
          <h2>{{ data[title] }}</h2>
          <time>{{ data.add_time }}</time>
        </header>
        <div class="gold_divider" />
        <div class="contract_box" v-html="data[content]" />
      </article>
    </section>
  </main>
</template>

<script>

    import Fetch from "../../utils/fetch";
    // import {VueEditor} from 'vue2-editor'

    export default {
        name: "NoticeArticle",
        /* components: {
            VueEditor
        }, */
        data() {
            return {
				title:"title_"+ (this.$i18n.locale||"zh_cn"),
				content:"content_"+ (this.$i18n.locale||"zh_cn"),
                data: {},
            };
        },
        created() {
            this.$parent.footer('user',false);
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/user/notice_view', {
                    id: this.$router.history.current.params.id
                }).then(res => {
                    this.data = res.data.view;
                })
            },
        }
    };
</script>

<style lang="less" scoped>
.notice_page { min-height: 100vh; padding-bottom: calc(78px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); color: #533126; }
.notice_header { display: grid; height: 50px; grid-template-columns: 48px 1fr 48px; align-items: center; border-bottom: 1px solid rgba(190, 139, 52, .45); background: rgba(255, 252, 245, .97); }.notice_header h1 { margin: 0; color: #873126; font-size: 16px; font-weight: 700; text-align: center; }.back_button { display: flex; width: 38px; height: 38px; align-items: center; justify-content: center; border: 0; background: transparent; }.back_button span { width: 12px; height: 12px; border-bottom: 2px solid #a6233d; border-left: 2px solid #a6233d; transform: rotate(45deg); }.header_spacer { width: 38px; height: 38px; justify-self: end; }
.notice_content { padding: 20px 14px 0; }.notice_card { overflow: hidden; padding: 17px 16px 19px; border: 1px solid rgba(190, 139, 52, .48); border-radius: 15px; background: #fffdf8; box-shadow: 0 13px 25px rgba(125, 82, 35, .08); }.notice_card_header { display: flex; min-width: 0; align-items: flex-start; gap: 12px; }.notice_card_header h2 { min-width: 0; flex: 1; margin: 0; color: #873126; font-size: 16px; font-weight: 700; line-height: 22px; }.notice_card_header time { flex: 0 0 auto; padding-top: 2px; color: #9b7256; font-size: 12px; line-height: 18px; text-align: right; }.gold_divider { height: 1px; margin: 14px 0 12px; background: linear-gradient(90deg, transparent, rgba(190, 139, 52, .55), transparent); }.contract_box { width: 100%; overflow-wrap: anywhere; color: #533126; font-size: 14px; line-height: 24px; }.contract_box /deep/ .ql-editor { padding: 0; color: inherit; font-size: inherit; line-height: inherit; }.contract_box /deep/ p { margin: 0 0 12px; }.contract_box /deep/ p:last-child { margin-bottom: 0; }.contract_box /deep/ h1, .contract_box /deep/ h2, .contract_box /deep/ h3, .contract_box /deep/ h4, .contract_box /deep/ h5, .contract_box /deep/ h6 { margin: 16px 0 9px; color: #873126; font-size: 16px; line-height: 22px; }.contract_box /deep/ ul, .contract_box /deep/ ol { padding-left: 20px; margin: 0 0 12px; }.contract_box /deep/ li { margin: 5px 0; }.contract_box /deep/ a { color: #a6233d; }.contract_box /deep/ img { display: block; max-width: 100%; height: auto; margin: 12px auto; border: 1px solid rgba(190, 139, 52, .34); border-radius: 9px; }.contract_box /deep/ table { display: block; max-width: 100%; overflow-x: auto; border-collapse: collapse; }.contract_box /deep/ td, .contract_box /deep/ th { padding: 7px; border: 1px solid rgba(190, 139, 52, .3); }.contract_box /deep/ blockquote { margin: 12px 0; padding-left: 12px; border-left: 2px solid #b9802e; color: #815c45; }
@media (max-width: 360px) { .notice_content { padding-right: 10px; padding-left: 10px; }.notice_card { padding-right: 13px; padding-left: 13px; }.notice_card_header { gap: 8px; }.notice_card_header time { max-width: 122px; }.contract_box { font-size: 14px; } }
</style>
